const Cell = ({size, color, column, row, onClick}) => {
    return (<rect x={column * size} y={row * size} height={size-2} width={size-2} 
        fillOpacity="0" 
        fill="black" 
        strokeWidth="2" 
        stroke={color}
        onClick={() => onClick && onClick({column, row})}/>);
}

export {Cell};